import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import { postGuestToken } from '../../api/orderHistory'
import LogInModal from '../../components/myshopping/LogInModal'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { OrderListInquiryWrap } from './OrderListInquiry'

export default function GuestOrderList() {
  const [orderNumber, setOrderNumber] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isModal, setIsModal] = useState<boolean>(false)
  const [loggedIn, setLoggedIn] = useState<boolean>(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { isAppView } = useAppContext()
  const { setIsLottie } = useCommonContext()

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false)
    }, 200)
  }, [location])
  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>비회원 주문 내역 조회</PageTitle>
            <OrderListInquiryWrap>
              <div className='input_cont'>
                <div className='input_box'>
                  <p>주문번호</p>
                  <input
                    type='text'
                    placeholder='주문번호를 입력해 주세요.'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setOrderNumber(e.target.value)
                    }}
                  />
                </div>
                <div className='input_box'>
                  <p>주문 비밀번호</p>
                  <input
                    type='password'
                    placeholder='주문 비밀번호를 입력해 주세요.'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setPassword(e.target.value)
                    }}
                  />
                </div>
              </div>
              <div className='btn_cont'>
                {/* <button type="button" className="cancel_btn">
                  취소
                </button> */}
                <button
                  type='button'
                  className='submit_btn'
                  onClick={() => {
                    postGuestToken(orderNumber, password)
                      .then((res) => {
                        if (isAppView) {
                          RNPostMessage(AFWebLinkType.moveToLink, {
                            url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/orderdetail/${res.data.orderNo}?guestToken=${res.data.guestToken}`,
                          })
                        } else {
                          navigate(`/orderdetail/${res.data.orderNo}`, {
                            state: { guestToken: res.data.guestToken },
                          })
                        }
                      })
                      .catch(() => alert('주문번호 및 주문 비밀번호를 확인해주세요.'))
                  }}
                >
                  조회
                </button>
              </div>
              <div className='orderpassword_find'>
                <p>주문 비밀번호를 잊으셨나요?</p>
                <button
                  type='button'
                  onClick={() => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/guestorderpassword`,
                      })
                    } else {
                      navigate(`/guestorderpassword`)
                    }
                  }}
                >
                  주문 비밀번호 찾기
                </button>
              </div>
            </OrderListInquiryWrap>

            {/* 회원 혜택 안내 */}
            {/* <BenefitWrap>
              <div className="benefit_txt">
                <strong>더 많은 혜택</strong>
                <p>
                  어바웃피싱에 회원가입하고
                  <br />
                  다양한 회원 혜택을 만나보세요!
                </p>
                <Link to="/benefit">혜택 자세히 보기</Link>
              </div>
              {isMobile ? <MarqueeBanner /> : <MarqueeLargeBanner />}
              <a
                href="#"
                className="line_btn"
                onClick={(e) => {
                  e.preventDefault();
                  setIsModal(true);
                }}
              >
                회원가입
              </a>
            </BenefitWrap> */}
          </div>
        </div>
        {isModal ? <LogInModal setLoggedIn={setLoggedIn}></LogInModal> : null}
      </div>
    </>
  )
}
